import { createSelector } from 'reselect';
import PredesPlannedTransportAnomaliesOriginDetailsColumns
  from '../../containers/PredesPlannedTransportAnomaliesOriginDetailsColumns';
import ReportDefinitions from '../../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime =
  state => state.reporting
    .PREDES_PLANNED_TRANSPORT_ANOMALIES_ORIGIN_DETAILS.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting
    .PREDES_PLANNED_TRANSPORT_ANOMALIES_ORIGIN_DETAILS.isLoading;

export const getData =
  ReportDefinitions
    .PREDES_PLANNED_TRANSPORT_ANOMALIES_ORIGIN_DETAILS.getDataFunction();

export const getColumns =
  createSelector(getData, PredesPlannedTransportAnomaliesOriginDetailsColumns);
